import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { getUser } from '@app/store/user/user.reducer';
import { State } from '@app/store';
import { IUser, User } from '@app/store/user';
import { environment } from '@app/../environments/environment';
import { Observable, Subject } from 'rxjs';
import {
  getSelectedList, SetSelectedList, LoadTodoHistory,
  LoadMyHistory, getMyHistory, getTodoHistory, IReportHistory, ResetTodo
} from './report-history-store/list';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-report-history',
  templateUrl: './report-history.component.html',
  styleUrls: ['./report-history.component.scss'],
  standalone: false
})
export class ReportHistoryComponent implements OnInit, OnDestroy {
  isReportManagementAccess = false;
  selectedOption = 'myreports';
  isGeneralMgr = false;
  employeeId: string;
  userName: string;
  cognosUrl = environment.cognosUrl;
  selectedList$: Observable<any>;
  private resetTodo: IReportHistory;
  destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private store: Store<State>,
  ) {
    this.selectedList$ = this.store.select(getSelectedList);
    this.store.select(getUser).pipe(takeUntil(this.destroy$)).subscribe(user => this.onUserLoaded(user));
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => this.processRoute(params));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.store.dispatch(new ResetTodo(this.resetTodo));
  }

  onUserLoaded(user: IUser) {
    if (user) {
      this.userName = User.nameAndProfile(user);
      this.employeeId = user.id;
      this.isReportManagementAccess = User.hasPrivilege(user, 'WEB_HISTORY_MANAGEMENT_ACCESS');
      this.isGeneralMgr = user.profileId === 7;
      this.getHistoryLists();
    }
  }

  // this can be refactored in the future since the only list we now have is my reports (removed all reports)
  processRoute(params: Params) {
    // since we're doing away with all reports, params?.option can/should only ever be myreports.
    // we will always just display My Reports
    this.displayReports('myreports');
    this.selectedOption = 'My Reports'
  }

  // this is called from the template
  displayReports(selectedReport: string) {
    this.store.dispatch(new SetSelectedList(selectedReport));
  }

  private getHistoryLists() {
    // Initialize lists if they haven't already been initialized

    this.store.select(getMyHistory).pipe(takeUntil(this.destroy$)).subscribe(myList => {
      if (myList.isLoading === null) {
        this.store.dispatch(new LoadMyHistory({
          employeeId: this.employeeId,
          filterString: ''
        }));
      }
    });

    // not implementing todo history until we are ready to display it
    // this.store.select(getTodoHistory).pipe(takeUntil(this.destroy$)).subscribe(todoList => {
    //   if (todoList.isLoading === null) {
    //     this.store.dispatch(new LoadTodoHistory(this.employeeId));
    //   }
    // });

    // not implementing all history
    // this.store.select(getAllHistory).pipe(takeUntil(this.destroy$)).subscribe(allList => {
    //     if (allList.isLoading === null) {
    //         this.store.dispatch(new LoadAllHistory(this.employeeId));
    //     }
    // });
  }
}
